module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || "b8pwqevy",
    dataset: process.env.GATSBY_SANITY_DATASET || "production",
  },
  auth: false,
};
